module.exports = __webpack_public_path__ + "img/title.f6929a63.png";